export const Color = {
  info: "info",
  success: "success",
  warning: "warning",
  error: "error",
};